import { BasketType } from './enums'
import Frame from './frame'
export default class Optician {
  public color!: string
  public id!: string
  public logo!: string
  public name!: string
  public theme!: string
  public priceType!: number

  public priceTypeText!: string
  public basketType!: BasketType
  public discountTitle!: string
  public discountPercentage!: number
  public showPrices!: boolean
  public initialGender!: number
  public basketTitle!: string

  public frames!: Frame[]
  public frameSelectionTitle!: string
  public frameSelectionSubTitle!: string
  public frameSelectionButton!: string
  public altTitleSun!: string
  public altTitleScreen!: string

  public glassImageType!: number
  // prices
  // totalprice
  // frame
  // public languageId!: string;
  // chaincolor
  // chainlogo
  // defaultrs
  // chainfontcolor
  // directory
  // subscription
  public looktwice!: boolean
  public dneye!: boolean
  public impressionist!: boolean
  // public languageCode!: string;
  public currency!: string
  // chainid
  // sun
  // mylife
  // mylifeperiod
  // sunhelp
  public version!: string
  // code
  // descriptiontotalprice

  constructor (optician: object) {
    Object.assign(this, { ...optician })
  }

  /*
    id: string;
    naam: string;
    logo: string;
    kleur: string;
    prijzen: number;
    totaalprijs: number;
    montuur: number;
    taal_id: string;
    keten_kleur: string;
    keten_logo: string;
    default_rs: number;
    keten_kleur_font: string;
    folder: string;
    abonnement: number;
    dneye: number;
    taal_code: string;
    valuta: string;
    keten_id: string;
    sun: number;
    mylife: number;
    mylife_periode: number;
    sun_help: null;
    versienummer: number;
    pincode: string;
    beschrijving_totaalprijs: string; */
}
